var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBigcommerce(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1930_21553)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.8642 39.8515H45.6897C48.199 39.8515 49.7893 38.4695 49.7893 36.251C49.7893 34.1581 48.199 32.6504 45.6897 32.6504H36.8642C36.5716 32.6504 36.3203 32.9017 36.3203 33.153V39.3508C36.3616 39.6415 36.5716 39.8515 36.8642 39.8515Z",
    fill: "#34313F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8642 54.1303H45.9823C48.7841 54.1303 50.4588 52.7069 50.4588 50.194C50.4588 48.0168 48.8685 46.2578 45.9823 46.2578H36.8642C36.5716 46.2578 36.3203 46.5091 36.3203 46.7604V53.5864C36.3616 53.9203 36.5716 54.1303 36.8642 54.1303Z",
    fill: "#34313F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.1556 0.153101L43.0541 26.199H47.3205C53.9707 26.199 57.9033 30.3865 57.9033 34.9509C57.9033 38.5515 55.4766 41.19 52.8848 42.3621C52.4665 42.529 52.4665 43.1159 52.926 43.2829C55.9379 44.4549 58.0702 47.596 58.0702 51.2809C58.0702 56.4736 54.5989 60.618 47.8644 60.618H29.3769C29.0843 60.618 28.833 60.3667 28.833 60.1155V40.3949L0.179189 68.9536C-0.195946 69.3305 0.0535458 70 0.597402 70H69.4894C69.7407 70 69.9489 69.79 69.9489 69.5387V0.530031C70.0746 0.0705359 69.4894 -0.180751 69.1556 0.153101Z",
    fill: "#34313F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1930_21553"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigcommerce);
export default __webpack_public_path__ + "static/media/bigcommerce.bf2c880edc06db6dbdf6bb2030dbb53f.svg";
export { ForwardRef as ReactComponent };